import { useMutation, useQueryClient } from "@tanstack/react-query";
import { MARK_MESSAGE_AS_READ } from "../api/queries";
import { graphQLClient } from "../graphqlClient";

export const useMarkAllMessagesAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ messages, userID }) => {
      if (!messages || messages.length === 0) {
        throw new Error("No messages to mark as read.");
      }

      // Keep the same expiry the create resolver set (creation + 30 days) --
      // this mutation overwrites each item's DynamoDB TTL, so passing "now"
      // would delete the messages as soon as they were read.
      const THIRTY_DAYS = 30 * 24 * 60 * 60;

      await Promise.all(
        messages.map((message) => {
          const createdAt = Date.parse(message.timestamp);
          const contractTTL = Number.isFinite(createdAt)
            ? Math.floor(createdAt / 1000) + THIRTY_DAYS
            : Math.floor(Date.now() / 1000) + THIRTY_DAYS;
          return graphQLClient.request(MARK_MESSAGE_AS_READ, {
            messageID: message.id,
            userID,
            path: message.path,
            contractTTL,
          });
        }),
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },
    onError: (error) => {
      console.error("❌ Error marking messages as read:", error);
    },
  });
};
